import React from 'react';
import { useSelector } from 'react-redux';
import { AdvancedMarker, useAdvancedMarkerRef } from "@vis.gl/react-google-maps";
import GoogleMapsInfoWindow from './GoogleMapsInfoWindow';
import { googleAnalytics } from '../../Services/googleAnalytics';

export default function GoogleMapsAdvancedMarker({ markerId, dealer, onToggleOpen, advancedMarkerIsOpen, advancedMarkerId }) {
  const googleMapState = useSelector((state) => state.resellermaplist);
  const [advancedMarkerRef, advancedMarker] = useAdvancedMarkerRef();

  return (
    <>
      {dealer &&
        dealer.resellerAddress.map((dealerInfo) => ((
          <AdvancedMarker
            key={`MAP_${markerId}_${dealerInfo.addressId}`}
            ref={advancedMarkerRef}
            position={{ lat: parseFloat(dealerInfo.latitude), lng: parseFloat(dealerInfo.longitude) }}
            onClick={() => {
              onToggleOpen(`MAP_${markerId}_${dealerInfo.addressId}`);
              googleAnalytics({
                event: 'dealerLocatorPopup',
                dealer: dealerInfo.shopName,
                click: 'open-popup'
              });
            }}>
            <img src={`${window.location.origin}${dealerInfo.partnericon}`} width={32} height={32} />
            {advancedMarkerIsOpen && advancedMarkerId === `MAP_${markerId}_${dealerInfo.addressId}` && googleMapState.advancedMarkerIsOpen && (
              <GoogleMapsInfoWindow advancedMarker={advancedMarker} dealer={dealerInfo} />
            )}
          </AdvancedMarker>
        )))}
    </>
  );
};